import LimitPaywallModal from './LimitPaywallModal'
export default LimitPaywallModal
